/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n=Symbol("GraphicInstance");function t(t){return null!=t&&"object"==typeof t&&n in t}export{n as GraphicSymbol,t as isGraphic};
